<template>
  <edit-modal
    caption="Leervragen importeren uit een bundel"
    :isActive="isActive">

    <div v-show="noDossier || profileMismatch" class="notification is-warning">
      <strong>Let op!</strong> Er is geen kwalificatiedossier gekoppeld aan de bundel waar je leervragen naartoe wilt kopieren <strong>of</strong> er is een dossier gekoppeld met een ander profiel. Alleen de leervragen van basiswerkprocessen en -kerntaken worden gekopieerd.<br>Koppel eerst een kwalificatiedossier met hetzelfde profiel om ook de profielvragen te kopieren.
    </div>

    <div class="field">
      <label
        for="bundleId"
        class="label">

        Selecteer de bundel waaruit de basislijsten gekopieerd moeten worden
      </label>
      <div class="control">
        <select-wrapper
          :value="bundleId"
          :options="myBundles"
          @input="update"
          placeholder="Kies een bundel">
        </select-wrapper>
      </div>
    </div>

    <div class="box">
      <h6 class="title is-6">
        Selecteer de gewenste kolommen

        <div class="field is-pulled-right has-addons">
          <p class="control">
            <button class="button" @click="selectAll">Selecteer alles</button>
          </p>
          <p class="control">
            <button class="button" @click="unselectAll">Selecteer niets</button>
          </p>
        </div>
      </h6>

      <div
        class="field"
        v-for="column in myColumns"
        :key="column.id">

        <div class="control">
          <label
            class="checkbox">

            <input type="checkbox" v-model="includedColumns" :value="column.id"> {{ column.name }}
          </label>
        </div>
      </div>
    </div>

    <div v-show="noDossier || profileMismatch" class="notification is-warning">
      <strong>Let op!</strong> Er is geen kwalificatiedossier gekoppeld aan de bundel waar je leervragen naartoe wilt kopieren <strong>of</strong> er is een dossier gekoppeld met een ander profiel. Alleen de leervragen van basiswerkprocessen en -kerntaken worden gekopieerd.<br>Koppel eerst een kwalificatiedossier met hetzelfde profiel om ook de profielvragen te kopieren.
    </div>

    <save-buttons
      @save="submit"
      @cancel="$emit('close')"
      :disabled="!valid">
    </save-buttons>
  </edit-modal>
</template>

<script>
import { mapGetters } from 'vuex'
import EditModal from '@/components/modules/EditModal'
import SaveButtons from '@/components/modules/SaveButtons'
import SelectWrapper from '@/components/wrappers/SelectWrapper'

export default {
  props: [
    'copy',
    'isActive'
  ],
  components: {
    EditModal,
    SaveButtons,
    SelectWrapper
  },
  data () {
    return {
      bundleId: null,
      includedColumns: []
    }
  },
  computed: {
    ...mapGetters({
      bundles: 'bundles/bundles',
      columns: 'columns/columns'
    }),
    myBundles () {
      return this.bundles.map((bundle) => {
        return {
          label: bundle.name,
          value: bundle.id
        }
      })
    },
    myColumns () {
      return this.columns.filter(column => column.id !== 34)
    },
    bundle () {
      if (this.copy) {
        return this.bundles.find(x => x.id === this.copy.to[0])
      }

      return null
    },
    valid () {
      if (this.copy) {
        return this.bundleId !== null &&
          this.includedColumns.length !== 0 &&
          !this.copy.to.includes(this.bundleId)
      }

      return false
    },
    noDossier () {
      return false
      // if (this.bundle) {
      //   return this.bundle.dossier_nr === null
      // }
    },
    profileMismatch () {
      return false
      // if (this.bundle && this.bundleId) {
      //   return (this.bundle.profile_nr !== this.bundleId) && this.includedColumns.includes(34)
      // }
    }
  },
  methods: {
    update (bundleId) {
      this.bundleId = bundleId
    },
    selectAll () {
      this.unselectAll()
      this.includedColumns = this.columns.map(column => column.id)
    },
    unselectAll () {
      this.includedColumns = []
    },
    submit () {
      this.$emit('save', {
        bundleId: this.bundleId,
        columns: this.includedColumns
      })
    }
  }
}
</script>
